
namespace RioERP.Orders {
    export class RazorPaySettingsColumns {
        static columnsKey = 'Orders.RazorPaySettings';
    }
}